import { Layout } from "../components/layout/layout.comp";
import { Pricing } from '../components/pricing/pricing.comp';

export default function PricingPage() {
  return (
    <Layout
      showHeader={true}
      showFooter={true}
      title="Pricing"
      description="Common Ninja's Bracket Widget Pricing."
      url="https://www.bracketsninja.com/pricing"
      isDark
    >
      <Pricing />
    </Layout>
  );
}
